import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5534a924")

_pushScopeId("data-v-5534a924")
const _hoisted_1 = { class: "h3 mb2" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "h3 mb2 mt4" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "h3 mb2 mt4" }
const _hoisted_6 = { class: "avatars-wrapper flex flex-wrap items-center" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "h4" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"admin-panel-branding__copyright\" data-v-5534a924> Icons made by <a href=\"https://www.freepik.com\" title=\"Freepik\" data-v-5534a924>Freepik,</a><a href=\"https://www.flaticon.com/authors/smalllikeart\" title=\"smalllikeart\" data-v-5534a924>smalllikeart,</a><a href=\"https://www.flaticon.com/authors/smashicons\" title=\"Smashicons\" data-v-5534a924>Smashicons</a> from <a href=\"https://www.flaticon.com/\" title=\"Flaticon\" data-v-5534a924>www.flaticon.com</a></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AdminPanelHeader = _resolveComponent("AdminPanelHeader")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_BaseBrandingItem = _resolveComponent("BaseBrandingItem")!
  const _component_BaseBox = _resolveComponent("BaseBox")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_AdminPanelHeader, {
      title: _ctx.$t('adminPanel.branding.title')
    }, null, 8, ["title"]),
    _createVNode(_component_BaseBox, { class: "admin-panel-branding__box" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('adminPanel.branding.logo')), 1),
        _createVNode("div", _hoisted_2, [
          (_ctx.logo)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "logo mr2",
                src: _ctx.logo,
                alt: "logo"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Upload, {
            mode: "basic",
            name: "logo",
            "custom-upload": true,
            accept: "image/png,image/jpg,image/jpeg",
            auto: "",
            "choose-label": _ctx.$t('adminPanel.branding.logoChoose'),
            "max-file-size": 1000000,
            onUploader: _ctx.uploadLogo
          }, null, 8, ["choose-label", "onUploader"]),
          (_ctx.saveLoading === 'logo')
            ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                key: 1,
                class: "p-progress-spinner--primary",
                "stroke-width": "3"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('adminPanel.branding.colors')), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_BaseBrandingItem, {
            class: "mb2",
            value: _ctx.brandColor,
            name: "primary",
            label: _ctx.$t('adminPanel.branding.companyColor'),
            onChange: _ctx.changeValue
          }, null, 8, ["value", "label", "onChange"]),
          (_ctx.saveLoading === 'brandColor')
            ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                key: 0,
                class: "p-progress-spinner--primary",
                "stroke-width": "3"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('adminPanel.branding.avatars')), 1),
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.avatars.sort(a => (a.name === _ctx.currentAvatarsPack.name ? -1 : 1)), (avatarObject) => {
            return (_openBlock(), _createBlock("div", {
              class: "avatars-list mr3 mb3",
              key: avatarObject.name
            }, [
              _createVNode("div", _hoisted_7, [
                _createVNode("h4", _hoisted_8, [
                  _createTextVNode(_toDisplayString(avatarObject.label[_ctx.$i18n.locale]) + " ", 1),
                  (_ctx.currentAvatarsPack.name === avatarObject.name)
                    ? (_openBlock(), _createBlock("span", _hoisted_9, " (" + _toDisplayString(_ctx.$t('adminPanel.branding.selected')) + ") ", 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.avatarsLoading === avatarObject.name)
                  ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                      key: 0,
                      class: "p-progress-spinner--primary mr2",
                      "stroke-width": "3"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", {
                class: ["avatars-list__box flex items-center justify-center flex-wrap", {
            'avatars-list__box--active': _ctx.currentAvatarsPack.name === avatarObject.name
          }],
                onClick: ($event: any) => (_ctx.saveAvatarsPack(avatarObject))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(avatarObject.list, (avatar) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "avatars-list__item mx1 my2",
                    key: avatar
                  }, [
                    _createVNode("img", {
                      src: require(`@/assets/avatars/${avatarObject.name}/${avatar}.svg`),
                      alt: `${avatarObject.name} ${avatar} avatar`
                    }, null, 8, ["src", "alt"])
                  ]))
                }), 128))
              ], 10, ["onClick"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _hoisted_10
  ], 64))
})